export const PAID_AMOUNT = "paidAmount";
export const PAID_DATE = "paidDate";
export const PAYMENT_STATUS = "paymentStatus";
export const IS_PAYMENT_RECEIVED = "isPaymentReceivedByCS";
export const PAYMENT_RECEIVED_ON = "paymentReceivedOn";
export const PAYMENT_REMARKS = "paymentRemarks";



export const paymentStatusOptions = [
  { label: "Partial Payment", value: "Paid" },
  { label: "Full Payment", value: "Completed" },
  // { label: "Unpaid", value: "Unpaid" },
];